import { useTourV2 } from 'core/tour-v2/TourProvider';

export const useIsTourActive = (tourKey: string) => {
  const { activeTourKey, currentStepId } = useTourV2();
  return activeTourKey === tourKey && currentStepId != null;
};
